export default IconArrowSharpTurnRight => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-sharp-turn-right" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M7 18v-11.31a.7 .7 0 0 1 1.195 -.495l9.805 9.805" />
  <path d="M13 16h5v-5" />
</svg>`;